import { mountApp } from '@/js/app-entries/app-entry-points/edu-ai-global';

mountApp();
